export enum LiabilityType {
  MORTGAGE = "MORTGAGE",
  PAYABLES = "PAYABLES",
  TRUST = "TRUST",
  JOINT = "JOINT",
}
